import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class StaticExportColumnSpecSearchCriteria extends ValueObject {
    public searchCriteria: string = "";

    public staticExportFileSpecId: number = 0;

    public fileTypeConcatenated: string | null = null;
}